import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ValueProposition from "./components/ValueProposition";
import FeatureGrid from "./components/FeatureGrid";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";
import SEOArticles from "./components/SEOArticles";
import ScrollReveal from "./components/ScrollReveal";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://hipobuyspreadsheet.biz";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/#website`,
  url: siteUrl,
  name: "Hipobuy Spreadsheet",
  description: "Outil de suivi e-commerce intelligent pour l'analyse produit, l'automatisation et l'optimisation des ventes en ligne.",
  inLanguage: "fr",
  publisher: {
    "@type": "Organization",
    "@id": `${siteUrl}/#organization`,
    name: "Hipobuy Spreadsheet",
    url: siteUrl,
  },
};

const webpageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `${siteUrl}/#webpage`,
  url: siteUrl,
  name: "Hipobuy Spreadsheet – Outil de Suivi E-commerce Intelligent | Analyse Produit & Automatisation",
  description: "Hipobuy Spreadsheet est l'outil ultime de suivi e-commerce intelligent. Automatisez l'analyse de vos produits, suivez les prix en temps réel et optimisez vos marges avec un spreadsheet nouvelle génération compatible dropshipping, Shopify et Amazon.",
  inLanguage: "fr",
  isPartOf: { "@id": `${siteUrl}/#website` },
  about: { "@id": `${siteUrl}/#organization` },
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Accueil",
        item: siteUrl,
      },
    ],
  },
};

export default function Home() {
  useEffect(() => {
    document.title = "Hipobuy Spreadsheet – Outil de Suivi E-commerce Intelligent | Analyse Produit & Automatisation";
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <JsonLd data={webpageSchema} />
      <Navbar />
      <main>
        <article>
          <Hero />
          <ScrollReveal><CategoryGrid /></ScrollReveal>
          <ScrollReveal><ValueProposition /></ScrollReveal>
          <ScrollReveal><FeatureGrid /></ScrollReveal>
          <ScrollReveal><Testimonials /></ScrollReveal>
          <ScrollReveal><CTASection /></ScrollReveal>
          <ScrollReveal><SEOArticles /></ScrollReveal>
        </article>
      </main>
      <Footer />
    </div>
  );
}